import { Column } from '../../../model/table';
import React from 'react';
import { ZoneTrafficCell } from './firewall-rules-table/zone-traffic-cell';
import { ServiceCell } from './firewall-rules-table/service-cell';
import { Rule } from '../../../dtos/version.dto';
import { RuleNamePopover } from './firewall-rules-table/rule-name-popover';
import { ProfileCell } from './firewall-rules-table/profile-cell';
import { LastUpdateContent } from './firewall-rules-table/last-update-content';
import { getUpdatedBy, isServiceRule } from '../../../utils/ruleUtils';
import { ZoneGeoCell } from './firewall-rules-table/zone-geo-cell';
import { ActionCell } from '../../shared/action-cell/action-cell';
import { ApplicationCell } from './firewall-rules-table/application-cell';
import { validateString } from '../../../utils/validationUtils';

export const rulesColumns: Column<Rule>[] = [
    {
        accessor: 'position',
        header: '#',
        width: '40px',
        sticky: 'first'
    },
    {
        accessor: 'displayName',
        header: 'Rule Name',
        width: '168px',
        getDisplayElement: (column, row) => <RuleNamePopover ruleData={row}/>,
        sticky: 'second',
        validationRules: [(value) => validateString(value)]
    },
    {
        accessor: 'src',
        header: 'Source',
        width: '368px',
        subColumns: [
            {
                accessor: 'src',
                header: 'Traffic',
                width: '240px',
                getDisplayElement: (column, row) => <ZoneTrafficCell ruleData={row.src}/>
            },
            {
                accessor: 'src',
                header: 'Geo-Location',
                width: '128px',
                getDisplayElement: (column, row) => <ZoneGeoCell ruleData={row.src} maxRegionsToDisplay={7}/>
            }
        ]
    },
    {
        accessor: 'dst',
        header: 'Destination',
        width: '368px',
        subColumns: [
            {
                accessor: 'dst',
                header: 'Traffic',
                width: '240px',
                getDisplayElement: (column, row) => <ZoneTrafficCell ruleData={row.dst}/>
            },
            {
                accessor: 'dst',
                header: 'Geo-Location',
                width: '128px',
                getDisplayElement: (column, row) => <ZoneGeoCell ruleData={row.dst} maxRegionsToDisplay={7}/>
            }
        ]
    },
    {
        accessor: 'service',
        header: 'Services',
        width: '200px',
        getDisplayElement: (column, row) => <ServiceCell servicesIds={row.service.services} isServiceRule={isServiceRule(row.displayName)} />
    },
    {
        accessor: 'application',
        header: 'Applications',
        width: '200px',
        getDisplayElement: (column, row) => <ApplicationCell applicationsIds={row.application.applications} />
    },
    {
        accessor: 'profiles',
        header: 'Profile',
        width: '190px',
        getDisplayElement: (column, row) => <ProfileCell profiles={row.profiles} />
    },
    {
        accessor: 'action',
        header: 'Action',
        width: '100px',
        getDisplayElement: (column, row) => <ActionCell action={row.action} />
    },
    {
        accessor: 'updatedDate',
        header: 'Last Update',
        width: '150px',
        getDisplayElement: (column, row) => <LastUpdateContent updatedBy={getUpdatedBy(row)} updatedDate={row.updatedDate} id={row.id} />
    }
];